import { render, staticRenderFns } from "./Grafico.vue?vue&type=template&id=05a1c21d"
import script from "./Grafico.vue?vue&type=script&lang=ts"
export * from "./Grafico.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports